export default "__VITE_ASSET__2c0c7f3d__"